// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Skeleton, TableCell, TableRow } from '@mui/material';

// ---------------------------------------------------------------------------
// Read-only skeleton row — matches the read-only table's 8-column structure.
// Shown while line items are loading independently.
// ---------------------------------------------------------------------------

export function ReadOnlySkeletonRow() {
  return (
    <TableRow>
      <TableCell>
        <Skeleton variant="text" width={20} />
      </TableCell>
      <TableCell>
        <Skeleton variant="rounded" height={20} sx={{ my: '10px' }} />
      </TableCell>
      <TableCell>
        <Skeleton
          variant="rounded"
          height={20}
          sx={{ my: '10px', width: '70%' }}
        />
      </TableCell>
      <TableCell align="right">
        <Skeleton variant="text" width={30} sx={{ ml: 'auto' }} />
      </TableCell>
      <TableCell align="right">
        <Skeleton variant="text" width={50} sx={{ ml: 'auto' }} />
      </TableCell>
      <TableCell align="right">
        <Skeleton variant="text" width={50} sx={{ ml: 'auto' }} />
      </TableCell>
      <TableCell align="right">
        <Skeleton variant="text" width={40} sx={{ ml: 'auto' }} />
      </TableCell>
      <TableCell align="right">
        <Skeleton variant="text" width={55} sx={{ ml: 'auto' }} />
      </TableCell>
    </TableRow>
  );
}

// ---------------------------------------------------------------------------
// Skeleton row — mimics the outlined TextField inputs in the edit row.
// Each cell renders a rounded skeleton matching the MUI small outlined
// input height (40px) with a subtle border to look like an empty field.
//
// IMPORTANT: Keep this in sync with EditableLineItemRow's column structure.
// If you add, remove, or reorder columns in the edit table, update this
// skeleton to match.
// ---------------------------------------------------------------------------

export function SkeletonRow() {
  return (
    <TableRow>
      <TableCell>
        <Skeleton
          variant="circular"
          width={24}
          height={24}
          sx={{ my: '8px' }}
        />
      </TableCell>
      <TableCell>
        <Skeleton variant="rounded" height={20} sx={{ my: '10px' }} />
      </TableCell>
      <TableCell>
        <Skeleton variant="rounded" height={20} sx={{ my: '10px' }} />
      </TableCell>
      <TableCell>
        <Skeleton variant="rounded" height={20} sx={{ my: '10px' }} />
      </TableCell>
      <TableCell>
        <Skeleton variant="rounded" height={20} sx={{ my: '10px' }} />
      </TableCell>
      <TableCell>
        <Skeleton variant="rounded" height={20} sx={{ my: '10px' }} />
      </TableCell>
      <TableCell>
        <Skeleton variant="rounded" height={20} sx={{ my: '10px' }} />
      </TableCell>
      <TableCell align="right">
        <Skeleton variant="rounded" height={20} sx={{ my: '10px' }} />
      </TableCell>
      <TableCell>
        <Skeleton
          variant="circular"
          width={24}
          height={24}
          sx={{ my: '8px' }}
        />
      </TableCell>
    </TableRow>
  );
}
